// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1tsG6","savePackageButton":"ClientWallet_savePackageButton__3tNSE"};